import React from 'react';
import { Reveal } from './Reveal';
const B1 = 'https://cdn.magicpatterns.com/uploads/gk1Ggt2fzoFSnErKGANurA/ChatGPT_Image_15_jul_2026,_09_48_25_a.m..png';
const B2 = 'https://cdn.magicpatterns.com/uploads/8eYaEsthEAxDAJQN149Utc/ChatGPT_Image_15_jul_2026,_09_50_03_a.m..png';
const B3 = 'https://cdn.magicpatterns.com/uploads/arGqfYwx8PEvHtWRQLuBMn/ChatGPT_Image_15_jul_2026,_09_52_53_a.m..png';
const B4 = 'https://cdn.magicpatterns.com/uploads/4LDoRCTzcpK8evG3kgibPV/ChatGPT_Image_15_jul_2026,_09_56_43_a.m..png';
const B5 = 'https://cdn.magicpatterns.com/uploads/a15f1frSKCQnFGX7xARA33/ChatGPT_Image_15_jul_2026,_09_59_16_a.m..png';
type Bonus = {
  image: string;
  eyebrow: string;
  title: string;
  description: string;
  points: string[];
};
const bonuses: Bonus[] = [{
  image: B1,
  eyebrow: 'OUTIL COMPLÉMENTAIRE 01',
  title: 'Matrices de Comptes-rendus Automatisées',
  description: 'Analysez vos interventions et évaluez la progression de vos patients sans logiciel coûteux.',
  points: ['6 matrices de bilans Word + PDF éditables', 'Banque de 200 phrases-types cliniques', 'Classées par trouble et niveau de sévérité']
}, {
  image: B2,
  eyebrow: 'OUTIL COMPLÉMENTAIRE 02',
  title: 'Checklists de Cotation et Guides de Correction',
  description: 'Feuille de route visuelle pour planifier chaque intervention, jour de bilan et étape de développement.',
  points: ['Checklists complètes par module', 'Organisées par âge et niveau de développement', 'Fiches profil cognitif synthétiques incluses']
}, {
  image: B3,
  eyebrow: 'OUTIL COMPLÉMENTAIRE 03',
  title: 'Livret de Communication Parents-École',
  description: 'Scripts exacts de communication et modèles professionnels pour renforcer la responsabilité et éliminer les malentendus.',
  points: ['Modèles de courriers professionnels', 'Fiches aménagements pédagogiques DYS & TDAH', 'FAQ complète avec réponses pré-rédigées']
}, {
  image: B4,
  eyebrow: 'OUTIL COMPLÉMENTAIRE 04',
  title: 'Tableau de Bord de Suivi des Patients',
  description: 'Système d\u2019évaluation pour suivre le développement cognitif, la progression et les objectifs atteints.',
  points: ['Tableau de bord visuel complet', 'Graphiques de progression automatiques Excel', 'Calendrier de réévaluation par domaine']
}, {
  image: B5,
  eyebrow: 'OUTIL COMPLÉMENTAIRE 05',
  title: 'Kit Administratif et Juridique du Cabinet',
  description: "Outils prêts à imprimer pour professionnaliser et protéger votre cabinet dès aujourd'hui.",
  points: ['Kit complet conforme RGPD', 'Formulaires consentement + charte confidentialité', 'Modèles devis, factures + guide conformité RGPD']
}];
export function Bonuses() {
  return <section className="w-full bg-ink-soft px-4 py-20" data-id="element-17">
      <div className="mx-auto max-w-6xl" data-id="element-18">
        <Reveal data-id="element-19">
          <div className="text-center" data-id="element-20">
            <h2 className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-21">
              🎁 Vous recevrez aussi 5 outils complémentaires
            </h2>
            <p className="mt-3 text-white/60" data-id="element-22">
              Inclus sans frais supplémentaires.
            </p>
            <p className="mt-2 text-sm font-bold uppercase tracking-wide text-gold" data-id="element-23">
              Valeur réelle : 27 € — aujourd'hui inclus GRATUIT
            </p>
          </div>
        </Reveal>

        <div className="mt-14 space-y-10" data-id="element-24">
          {bonuses.map((b, i) => <Reveal key={b.eyebrow} delay={i % 2 * 0.06} data-id="element-25">
              <article className="flex flex-col items-center rounded-2xl border border-ink-border bg-ink-card p-6 text-center sm:p-8" data-id="element-26">
                <img src={b.image} alt={b.title} className="h-auto w-full max-w-sm rounded-xl object-contain shadow-xl shadow-black/30 sm:max-w-md" data-id="element-27" />
                <div className="mt-7 max-w-2xl" data-id="element-28">
                  <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-29">
                    <span className="text-xs font-bold uppercase tracking-widest text-white/50" data-id="element-30">
                      {b.eyebrow}
                    </span>
                    <span className="rounded-full bg-gold/15 px-3 py-1 text-xs font-bold uppercase text-gold" data-id="element-31">
                      Valeur : 17€ — GRATUIT
                    </span>
                  </div>
                  <h3 className="mt-3 text-xl font-extrabold text-white" data-id="element-32">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-33">
                    {b.description}
                  </p>
                  <ul className="mt-4 space-y-2 text-left" data-id="element-34">
                    {b.points.map(p => <li key={p} className="flex items-start gap-2 text-sm text-white/80" data-id="element-35">
                        <span className="mt-0.5 text-gold" data-id="element-36">✦</span> {p}
                      </li>)}
                  </ul>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}